import { AppLanguage } from '~/types/locale'

export const getOverallGrade = (progress: number, locale: AppLanguage) => {
  if (!progress) return '-'
  if (locale === AppLanguage.NO) {
    if (progress >= 94) return '6'
    if (progress >= 75) return '5'
    if (progress >= 60) return '4'
    if (progress >= 40) return '3'
    if (progress >= 20) return '2'
    return '1'
  }
  if (progress >= 90) return 'A'
  if (progress >= 80) return 'B'
  if (progress >= 70) return 'C'
  if (progress >= 60) return 'D'
  if (progress >= 50) return 'E'
  return 'F'
}

export const formatTimeSpent = (timeSpentInMilliseconds: number | null | undefined): string => {
  if (timeSpentInMilliseconds === 0 || timeSpentInMilliseconds == null) return '0m'
  const totalSeconds = Math.floor(timeSpentInMilliseconds / 1000)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  if (hours > 0) return `${hours}h ${minutes}m`
  return `${minutes}m ${seconds}s`
}

export const formatXP = (xp: number): string => {
  if (xp >= 1_000_000) return `${(xp / 1_000_000).toFixed(1)}M XP`
  if (xp >= 1_000) return `${(xp / 1_000).toFixed(1)}K XP`
  return `${xp} XP`
}

export const calculateAccuracy = (correctAnswers: number, totalAnswers: number): string => {
  if (totalAnswers === 0) return '0%'
  const accuracy = Math.round((correctAnswers / totalAnswers) * 100)
  return `${accuracy}%`
}

export const calculateProgress = (completed: number, total: number): number => {
  if (total === 0) return 0
  return Math.round((completed / total) * 100)
}

export const getTimeInMiliSecond = (props: { days: number; hours: number; minutes: number }): number => {
  const { days, hours, minutes } = props
  return (days * 86400 + hours * 3600 + minutes * 60) * 1000
}
